define([
        'moment',
        'uuid'
    ], (moment, uuid) => {

        return ['GTMProvider', 'ContextService', (GTMProvider, ContextService) => {

            const service = {
                pushPurchaseDataToDataLayer: pushPurchaseDataToDataLayer,
                createId: createId
            }

            function pushPurchaseDataToDataLayer(price, isCompany) {
                const product = ContextService.getProductCode();
                const subproduct = ContextService.getSubproductCode();

                GTMProvider.pushToDataLayer(createTransactionDataForPurchase({
                    id: createId(),
                    affiliation: (product !== undefined) ? product: '',
                    productName: (subproduct !== undefined) ? subproduct : '',
                    productPrice: (price !== undefined) ? price : '',
                    productBrand: Boolean(isCompany) ? 'Unternehmenskunden' : 'Privatkunden',
                }))
            }

            function createId() {
                return `BDMF_${moment().format("YYYYMMDD")}_${uuid.v4()}`;
            }

            function createTransactionDataForPurchase(data = {}) {
                const {
                    affiliation,
                    id,
                    productName,
                    productPrice,
                    productBrand,
                } = data;

                return {
                    "event": "Enhanced_Ecommerce_Transaction",
                    "ecommerce": {
                        "purchase": {
                            "actionField": {
                                id,
                                affiliation,
                                "revenue": "",
                            },
                            "products": [
                                {
                                    "id": "",
                                    "name": productName,
                                    "price": productPrice,
                                    "brand": productBrand,
                                    "category": "Fahrzeuge",
                                    "variant": "",
                                    "quantity": 1
                                }
                            ]
                        }
                    }
                };
            }

            return service;
        }]
    }
)



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/GoogleTagManagerService.js